// extracted by mini-css-extract-plugin
export default {"daoList":"styles_daoList__FJctk"};